import { Entity } from "@common/types/entity";

export interface AccrualLedgerSettingsRow {
    id: number;
    entity: Entity;
}

export function buildAccrualLedgerSettingsRows(
    entities: Entity[],
): AccrualLedgerSettingsRow[] {
    return entities.map((entity) => ({ id: entity.id, entity }));
}
